//const localBaseApiURL = 'https://app-api-staging-us-stack-001.azurewebsites.net/api/portal/';
const localBaseApiURL = 'http://localhost:1082/api/portal';


export const BASE_API_URL = process.env.REACT_APP_API || localBaseApiURL;
export const API_HEADER_APP_CONTEXT = 'nh-portal';
export const MEDIA_CREATOR_BASE_URL = process.env.REACT_APP_MEDIA_CREATOR_BASE_URL || 'https://app-media-creator-staging-us-stack-001.azurewebsites.net';
export const ENV = process.env.REACT_APP_ENV || 'staging';
export const COMMIT_ID = process.env.REACT_APP_COMMIT_ID || '*NO COMMIT ID*';
export const WEBSITE_WIDGET_URL = process.env.REACT_APP_ENV !== 'production' ?
    'https://sausstackcorexvnb.blob.core.windows.net/uss-review-external-widget/current/index.js'
    : 'https://sausstackcoreprodxvnb.blob.core.windows.net/uss-review-external-widget/current/index.js';
export const WEBSITE_WIDGET_ID = 'review-widget';
export const WEBSITE_WIDGET_SCRIPT_ID = 'review-widget-script';
